import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Grid, Paper, useMediaQuery } from '@mui/material';
import Titlebar from '../TitleBar';
import { Pagination, SearchTable, TableBody3, TableBottom3, TableHeader } from '.';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import { applyFilter, emptyRows, getComparator, extractDate } from '../../Utils/table';
import { adminStkInwMenu, StkInwMenu, Zones } from '../TitleList';
import { selectStkItemSize } from '../Selectors/Master/OutwardSelectors';
import { fetchStockItemSize } from '../../Store/PHPSlice/stockApi';
import DateInputComponent2 from '../FieldsComponents/DateInputComponent2';
import styled, { cutDates, inputStyles, stockNumber, inputNumbersmall, inputStyle11 } from '../../Utils/inputChanges';


const StockReg = () => {
    const dispatch = useDispatch();
    const getItems = useSelector(selectStkItemSize);
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const isDesktop = useMediaQuery('(min-width:768px)');
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('empId');
    const [selected, setSelected] = useState([]);
    const [filterName, setFilterName] = useState('null');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");
    const [firstIndex, setFirstIndex] = useState(0);
    const [lastIndex, setLastIndex] = useState(0);

    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [pageRange, setPageRange] = useState([0, 10]); // Initial range [0, 10]
    const [searchTerm, setSearchTerm] = useState('');

    const [formData, setFormData] = useState({
        fdt: '',
        tdt: '',
        barcd: '',
    });
    const [activeMenu, setActiveMenu] = useState(StkInwMenu);

    useEffect(() => {
        dispatch(fetchStockItemSize());
    }, [dispatch]);

    useEffect(() => {
        if (!userdata) return;


        if (userdata?.pageIds?.length > 0 && userdata?.role !== '1') {
            const pid = userdata?.pageIds?.find(item => item === 1);
            if (pid === 1 && userdata?.role === '3') {
                setActiveMenu(adminStkInwMenu);
            } else {
                setActiveMenu(StkInwMenu);
            }


        }
    }, []);

    if (!getItems) {
        return <h1>Loading...</h1>;
    }


    const compData = Array.isArray(getItems.data) ? getItems.data.map((item, index) => (
        {
            srNo: item.ID,
            stkId: item.stkId,
            stkBarcode: item.stkBarcode,
            itemId: item.itemId,
            itemNm: item.itemNm,
            size: item.size,
            color: item.color,
            gqty: item.qty,
            bqty: item.bqty,
            prate: item.prate,
            srate: item.srate,
            sts: item.sts,
            serialNumber: index + 1
        }
    )) : [];

    const handleSort = (event, id) => {
        const isAsc = orderBy === id && order === 'asc';
        if (id !== '') {
            setOrder(isAsc ? 'desc' : 'asc');
            setOrderBy(id);
        }
    };
    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = compData.map((n) => n.name);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }
        setSelected(newSelected);
    };



    const totalCount = compData.length;
    const npages = Math.ceil(totalCount / recordsPerPage);
    const numbers = Array.from({ length: npages }, (_, i) => i + 1);


    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reset to first page on search
    };

    const filteredData = (Array.isArray(compData) ? compData : []).filter(item =>
        item?.itemNm?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    const saledata = filteredData?.map(item => ({
        key: item.key,
        sqty: parseFloat(item.gqty) - parseFloat(item.bqty)
    }));

    const totsaleqty = saledata?.reduce((acc, sum) => acc + parseFloat(sum.sqty), 0);
    const totstkqty = filteredData?.reduce((acc, sum) => acc + parseFloat(sum.gqty), 0);
    const totbalqty = filteredData?.reduce((acc, sum) => acc + parseFloat(sum.bqty), 0);
    const totprate = filteredData?.reduce((acc, sum) => acc + parseFloat(sum.prate), 0);
    const totsrate = filteredData?.reduce((acc, sum) => acc + parseFloat(sum.srate), 0);
    // console.log(filteredData)

    const dataFiltered = applyFilter({
        inputData: filteredData,
        comparator: getComparator(order, orderBy),
    });

    const totalPages = Math.ceil(dataFiltered.length / itemsPerPage);
    const displayedData = dataFiltered.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);


    const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);
    const visiblePageNumbers = pageNumbers.slice(pageRange[0], pageRange[1]);

    const handleNextPageRange = () => {
        setPageRange([pageRange[0] + 5, pageRange[1] + 5]);
    };

    const handlePreviousPageRange = () => {
        setPageRange([pageRange[0] - 5, pageRange[1] - 5]);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(Number(event.target.value));
        setCurrentPage(1); // Reset to first page on change
    };
    // console.log(displayedData);

    const fields = [
        { label: 'From Date', name: 'fdt', type: 'date' },
        { label: 'To Date', name: 'tdt', type: 'date' },
        // { label: 'Barcode', name: 'freight_ch' },
    ];

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });

    };

    const handleSearch = (e) => {
        e.preventDefault();

        if (formData.fdt === '') {
            alert('Please Select From Date.');
            return; // Stop form submission
        }
        if (formData.tdt === '') {
            alert('Please Select To Date.');
            return; // Stop form submission
        }
        const postobj = {
            fdt: formData.fdt,
            tdt: formData.tdt
        };
        dispatch(fetchStockItemSize(postobj));
    };

    return (
        <>
            <Titlebar data={activeMenu} />

            <div style={{ margin: '1% 0.5%' }}>
                <h2>Stock Register</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>



                            <Grid container spacing={0.5}>
                                {fields.map((field) => (
                                    <DateInputComponent2
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleInputChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSearch}>Search</Button>

                                </Grid>
                            </Grid>

                            <Grid item xs={12} textAlign="center" style={{ marginTop: '4%' }}>
                            </Grid>

                            <SearchTable
                                handleItemsPerPageChange={handleItemsPerPageChange}
                                searchTerm={searchTerm}
                                handleSearchChange={handleSearchChange}
                                totalItems={filteredData?.length}
                            />


                            <TableContainer style={{ marginTop: '2%', border: '1px solid #ccc' }}>
                                <Table>
                                    <TableHeader
                                        headCells={[
                                            { id: 'srNo', label: 'Sr.No' },
                                            { id: 'stkBarcode', label: 'Barcode' },
                                            { id: 'itemNm', label: 'Item' },
                                            { id: 'size', label: 'size' },
                                            { id: 'color', label: 'color' },
                                            { id: 'gqty', label: 'Stock Qty.' },
                                            { id: '', label: 'Sale Qty.' },
                                            { id: 'bqty', label: 'Bal Qty' },
                                            { id: 'prate', label: 'Purchase Rate' },
                                            { id: 'srate', label: 'Sale Rate' },
                                            // { id: 'edit', label: 'Edit' },
                                            { id: 'delete', label: 'Delete' }
                                        ]}

                                        order={order}
                                        orderBy={orderBy}
                                        onRequestSort={handleSort}
                                        numSelected={selected.length}
                                        rowCount={compData.length}
                                        onSelectAllClick={handleSelectAllClick}
                                    />
                                    <tbody>
                                        {displayedData && displayedData.length > 0 ? (
                                            <>
                                                {displayedData?.map((row) => (
                                                    <TableBody3
                                                        key={row.srNo}
                                                        stkBarcode={row.stkBarcode}
                                                        itemId={row.itemId}
                                                        itemNm={row.itemNm}
                                                        size={row.size}
                                                        color={row.color}
                                                        gqty={row.gqty}
                                                        bqty={row.bqty}
                                                        srate={row.srate}
                                                        prate={row.prate}
                                                        sts={row.sts}
                                                        serialNumber={row.serialNumber}
                                                        selected={selected.indexOf(row.name) !== -1}
                                                        handleClick={(event) => handleClick(event, row.name)}
                                                    />
                                                ))}

                                                <TableBottom3
                                                    totsaleqty={totsaleqty}
                                                    totbalqty={totbalqty}
                                                    totstkqty={totstkqty}
                                                    totprate={totprate}
                                                    totsrate={totsrate}
                                                />
                                            </>
                                        ) : (
                                            <tr>
                                                <td colSpan={12} style={{ textAlign: "center", padding: "10px" }}>
                                                    No data available
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </TableContainer>

                            <Pagination
                                currentPage={currentPage}
                                handlePageChange={handlePageChange}
                                handlePreviousPageRange={handlePreviousPageRange}
                                visiblePageNumbers={visiblePageNumbers}
                                pageNumber={pageNumbers}
                                pageRange={pageRange}
                                totalPages={totalPages}
                                handleNextPageRange={handleNextPageRange}
                            />
                        </Paper>
                    </Grid>
                </Grid>
            </div>

        </>
    );
}

export default StockReg;
